import { Component, OnInit } from '@angular/core';
import {
  BackButtonConfig,
  BackButtonService,
} from '../../services/back-button.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit {
  public backButtonConfig$: Observable<BackButtonConfig>;
  constructor(private backButtonService: BackButtonService) {
    this.backButtonConfig$ = this.backButtonService.getBackButtonConfig();
  }

  ngOnInit(): void {}

  ionViewWillEnter(): void {}

  goBack(): void {
    this.backButtonService.goBack();
  }
}
